import { useNotifications } from '../../context/NotificationContext';
import { formatCounter } from '../../utils/formatCounter';

export const NotificationBadge = ({ className = '' }) => {
  const { totalCounts } = useNotifications();

  if (totalCounts <= 0) return;

  return (
    <div
      className={`absolute -top-0.5 -right-0.5 bg-[#A1F69E] text-black rounded-full min-w-[16px] h-[16px] flex items-center justify-center text-[10px] font-bold px-1 ${className}`}
    >{formatCounter(totalCounts)}</div>
  );
};
